<template lang="pug">
div
  .d-flex.justify-space-between.align-center.mb-2
    .text-sm.font-semibold Notes
    //- Edit actions
    template(v-if="isNotesEditMode")
      .d-flex.align-center
        v-btn.button-xs.text-xs.underline.danger500--text(text :disabled="isLoading" @click="onCancel") Cancel
        v-btn.button-xs.text-xs.underline(text :loading="isLoading" :disabled="isEmptyEditingNotes" @click="onSave") Save
    template(v-else)
      .text-xs.font-semibold.hover-bg.px-1.rounded-md.underline(v-if="notesItem.text" @click="onEditNote") Edit note
  .mb-2
    //- Edit field
    template(v-if="isNotesEditMode")
      v-textarea(v-model="editingNotes" dense outlined hide-details autofocus rows="3")
    template(v-else)
      template(v-if="notesItem.text")
        .text-sm.prewrap(v-html="notesItem.text")
      template(v-else)
        .neutral500--text.italic.text-xs.clickable(@click="onEditNote") Enter notes
  .text-xs.neutral500--text(v-if="hasNotesInfo") Created&nbsp;
    span(v-if="notesItem.createdBy") by {{ notesItem.createdBy }}&nbsp;
    span(v-if="notesItem.createdDate") on {{ notesItem.createdBy }}&nbsp;
    span(v-if="notesItem.createdTime") at {{ notesItem.createdTime }}&nbsp;
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    appointment: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      isLoading: false,
      isNotesEditMode: false,
      editingNotes: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    notesItem () {
      return {
        text: this.appointment?.lead?.remarks || null,
        createdBy: null,
        createdDate: null,
        createdTime: null
      }
    },
    hasNotesInfo () {
      return this.notesItem.createdBy && this.notesItem.createdDate && this.notesItem.createdTime
    },
    getText () {
      return this.appointment?.lead?.remarks || null
    },
    isEmptyEditingNotes () {
      return this.editingNotes === null || this.editingNotes === ''
    },
    payload () {
      return {
        lead: {
          remarks: this.editingNotes
        }
      }
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany.slug : this.company.slug
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    onEditNote () {
      if (this.appointment?.lead?.remarks) {
        this.editingNotes = this.appointment.lead.remarks
      }
      this.isNotesEditMode = true
    },
    onCancel () {
      this.isNotesEditMode = false
      this.editingNotes = null
    },
    async onSave () {
      try {
        this.isLoading = true
        await this.$axios.patch(`/clinics/${this.companySlug}/appointments/${this.appointment.id}`, this.payload)
        this.$emit('updated', this.editingNotes)
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isNotesEditMode = false
        this.editingNotes = null
        this.isLoading = false
      }
    }
  },
}
</script>

<style scoped>
.prewrap {
  white-space: pre-wrap;
}
</style>